import { queryOptions } from '@tanstack/react-query'
import { unwrap } from '@/lib/api'
import { type VenueDetailResponse, type VenuesResponse, venueWorkspaceApi } from './types'

export const venueKeys = {
  all: (slug: string) => ['venues', slug] as const,
  detail: (slug: string, venueId: string) => ['venues', slug, venueId] as const,
}

export const venuesQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: venueKeys.all(slug),
    queryFn: () => unwrap<VenuesResponse>(venueWorkspaceApi.venues.$get({ param: { slug } })),
  })

export const venueDetailQueryOptions = (slug: string, venueId: string) =>
  queryOptions({
    queryKey: venueKeys.detail(slug, venueId),
    queryFn: () =>
      unwrap<VenueDetailResponse>(
        venueWorkspaceApi.venues[':venueId'].$get({ param: { slug, venueId } }),
      ),
  })
